function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 1",
    d: "M772.1 1800.1a20.006 20.006 0 1 1 20 20 20.024 20.024 0 0 1-20-20zm11.439.325a1.115 1.115 0 0 0 0 1.573l4.445 4.444a1.111 1.111 0 0 0 1.575 0l11.113-11.111a1.113 1.113 0 1 0-1.575-1.573l-10.326 10.327-3.659-3.66a1.108 1.108 0 0 0-1.573 0z",
    transform: "translate(-772.102 -1780.1)",
    style: {
      fill: "#492cbd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCheckCircle);
export default __webpack_public_path__ + "static/media/purple-check-circle.5e07dd0c.svg";
export { ForwardRef as ReactComponent };